import { useState, useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import InvoiceImagePreview from "../../components/InvoiceImagePreview";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanelLawyer from '../../components/NavigationPanelLawyer';
import Upload from '../../components/Upload';
import Footer from '../../components/Footer';

const CDI_4 = () => {
    const navigate = useNavigate();
  	const [isInvoiceImagePreviewOpen, setInvoiceImagePreviewOpen] = useState(false);
  	const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  	
  	const onClickClientInstruction = useCallback(() => {
		navigate('/cdi1');
  	}, [navigate]);
  	
  	
  	const onFrameContainer2Click = useCallback(() => {
        navigate('/cdi2');
  	}, [navigate]);
  	
  	
  	const openInvoiceImagePreview = useCallback(() => {
    		setInvoiceImagePreviewOpen(true);
  	}, []);
  	
  	const closeInvoiceImagePreview = useCallback(() => {
    		setInvoiceImagePreviewOpen(false);
  	}, []);
  	
  	const closeLogoutConfirmation = useCallback(() => {
    		setLogoutConfirmationOpen(false);
  	}, []);

	const navItems = [
		{ text: "Dashboard", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/dashboard" },
		{ text: "Legal proceedings & billing", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/legal_1" },
		{ text: "Pre-LBA checks", bgColor: "bg-neutrals-neutral-50", textColor: "text-neutrals-neutral-300", hoverBgColor: "bg-neutrals-neutral-50", hoverTextColor: "text-primary-primary-500", path: "/prelbacheck" },
		{ text: "Client-debtor interaction", bgColor: "bg-primary-primary-50", textColor: "text-neutrals-neutral-900", hoverBgColor: "bg-primary-primary-50", hoverTextColor: "text-neutrals-neutral-900", path: "" },
	];
  	
  	return (<>
    		<div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-ff-heading-2">
      			{/* Navigation Panel */}
				<NavigationPanelLawyer navItems={navItems}/>

				{/* Main */}
				<div className='w-full absolute top-[128px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border'>
					{/* Heading */}
					<div className="self-stretch flex flex-col items-start justify-start gap-1">
						<b className="self-stretch relative text-9xl">Client-debtor interaction</b>
						<div className="self-stretch relative text-base text-neutrals-neutral-300">{`Get all your information for client & debtor over here.`}</div>
					</div>
					<div className='self-stretch flex flex-col items-start justify-start gap-6 text-base text-neutrals-neutral-300'>
						{/* Tabs */}
						<div className="flex flex-row items-start justify-start gap-6">
							<div className="bg-white h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer" onClick={onClickClientInstruction}>
								<div className="flex flex-row items-center justify-center">
									<div className="relative font-semibold">Client instructions</div>
								</div>
							</div>
							<div className="bg-white border-primary-primary-500 border-solid border-b-[2px] box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500">
								<div className="flex flex-row items-center justify-center">
									<div className="relative font-semibold">Handling defences</div>
								</div>
							</div>
						</div>
						<div className='self-stretch flex flex-col items-start justify-start gap-8 text-lg text-neutrals-neutral-900'>
							<div className="self-stretch flex flex-col items-start justify-start gap-1.5">
								<div className="self-stretch relative font-semibold">Debt collection - 123</div>
								<div className="self-stretch relative text-base text-neutrals-neutral-300">#REF-123</div>
							</div>
							<div className="self-stretch flex flex-row items-center justify-start gap-1.5 cursor-pointer text-base" onClick={onFrameContainer2Click}>
								<img className="w-5 relative h-5" alt="" src="assets/arrow-left.svg" />
								<div className="relative">Back to list</div>
							</div>
							<div className='self-stretch flex flex-col items-start justify-start gap-8'>
								<div className="self-stretch flex flex-col items-start justify-start gap-6">
									<div className="self-stretch flex flex-col items-start justify-start gap-1.5">
										<div className="self-stretch relative font-semibold">Debtor’s response</div>
										<div className="self-stretch relative text-base">I dispute the debt due to incomplete services rendered. Attached are relevant invoices and communications.</div>
									</div>
									<div className="self-stretch relative text-base">
										<p className="m-0 font-semibold">Key arguments:</p>
										<ul className="m-0 text-inherit pl-[21px]">
											<li className="mb-0">
												<span>Incomplete services</span>
											</li>
											<li>
												<span>Request for additional documentation</span>
											</li>
										</ul>
									</div>
								</div>
								<div className='self-stretch flex flex-col items-start justify-start gap-2.5 text-sm'>
									<Upload  width="1024px"/>
								</div>
								<div className='self-stretch flex flex-col items-start justify-start gap-6'>
									<div className="w-full border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex flex-col items-start justify-start pt-0 px-0 pb-6">
										<div className="self-stretch flex flex-row items-start justify-between gap-0">
											<div className="flex-1 flex flex-col items-start justify-start gap-1.5">
												<div className="relative font-semibold">Attached documents</div>
												<div className="relative text-base text-neutrals-neutral-300">List of all attached documents.</div>
											</div>
											<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 text-sm">
												<div className="flex flex-row items-center justify-center gap-1.5">
													<img className="w-5 relative h-5" alt="" src="assets/download.svg" />
													<div className="relative font-semibold">Download all</div>
												</div>
											</div>
										</div>
									</div>
									<div className='w-full flex flex-row items-start justify-start flex-wrap content-start gap-6 text-base'>
										{/* Document 1 */}
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
											<div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
												<div className="flex flex-col items-start justify-start gap-2.5">
													<img className="w-10 relative h-10" alt="" src="assets/pdf.svg" />
													<div className="relative font-semibold">Invoice.pdf</div>
													<div className="relative text-neutrals-neutral-300">1.2MB</div>
												</div>
												<div className="relative text-neutrals-neutral-300">29/01/24</div>
											</div>
											<div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
												<div className="flex flex-row items-start justify-end gap-2.5">
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer" onClick={openInvoiceImagePreview}>
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/preview.svg" />
															<div className="relative font-semibold">Preview</div>
														</div>
													</div>
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5">
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/download.svg" />
															<div className="relative font-semibold">Download</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										{/* Document 2 */}
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
											<div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
												<div className="flex flex-col items-start justify-start gap-2.5">
													<img className="w-10 relative h-10" alt="" src="assets/pdf.svg" />
													<div className="relative font-semibold">Email communication.pdf</div>
													<div className="relative text-neutrals-neutral-300">2.9MB</div>
												</div>
												<div className="relative text-neutrals-neutral-300">29/01/24</div>
											</div>
											<div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
												<div className="flex flex-row items-start justify-end gap-2.5">
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer" onClick={openInvoiceImagePreview}>
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/preview.svg" />
															<div className="relative font-semibold">Preview</div>
														</div>
													</div>
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5">
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/download.svg" />
															<div className="relative font-semibold">Download</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										{/* Document 3 */}
										<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
											<div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
												<div className="flex flex-col items-start justify-start gap-2.5">
													<img className="w-10 relative h-10" alt="" src="assets/word_file.svg" />
													<div className="relative font-semibold">Documentation_request.docx</div>
													<div className="relative text-neutrals-neutral-300">24KB</div>
												</div>
												<div className="relative text-neutrals-neutral-300">29/01/24</div>
											</div>
											<div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
												<div className="flex flex-row items-start justify-end gap-2.5">
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 cursor-pointer" onClick={openInvoiceImagePreview}>
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/preview.svg" />
															<div className="relative font-semibold">Preview</div>
														</div>
													</div>
													<div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5">
														<div className="flex flex-row items-center justify-center gap-1.5">
															<img className="w-5 relative h-5" alt="" src="assets/download.svg" />
															<div className="relative font-semibold">Download</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Response dropdown */}
								<div className="self-stretch flex flex-col items-start justify-start gap-2.5 text-sm">
									<div className="flex flex-row items-start justify-start gap-1.5">
										<div className="relative font-semibold">Response option</div>
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/help-circle.svg" />
									</div>
									<div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-row items-end justify-start py-3.5 px-2.5 gap-[175px] text-base text-neutrals-neutral-300">
										<div className="w-[162px] relative inline-block shrink-0">Select response</div>
										<img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src="assets/arrow-down.svg" />
									</div>
								</div>
								<Footer/>
							</div>
						</div>
					</div>
				</div>
      			
    		</div>
    		{isInvoiceImagePreviewOpen && (
      			<PortalPopup
        				overlayColor="rgba(113, 113, 113, 0.3)"
        				placement="Centered"
        				onOutsideClick={closeInvoiceImagePreview}
        				>
        				<InvoiceImagePreview onClose={closeInvoiceImagePreview} />
      			</PortalPopup>
    		)}
    		{isLogoutConfirmationOpen && (
      			<PortalPopup
        				overlayColor="rgba(113, 113, 113, 0.3)"
        				placement="Centered"
        				onOutsideClick={closeLogoutConfirmation}
        				>
        				<LogoutConfirmation onClose={closeLogoutConfirmation} />
      			</PortalPopup>
    		)}</>);
};

export default CDI_4;